import { useEffect } from 'react'
import { ApprovalConfirmationPage, CodeController, DirectNoticePage, NotFoundPage } from '../pages'
import LoadingPage from '../pages/LoadingPage'
import { useAuth } from '../providers/auth'
import { ConsentStatus, UserTypes } from '../types/Account'

const statusRenderer = (status: ConsentStatus) => {
  switch (status) {
    case ConsentStatus.REQUEST_SENT:
      return <DirectNoticePage />
    case ConsentStatus.APPROVED:
      return <ApprovalConfirmationPage />
    case ConsentStatus.REVOKED:
      return <NotFoundPage />
    default:
      return <NotFoundPage />
  }
}

const ApproverRouter = () => {
  const { authState, logout } = useAuth()

  // if user has the wrong type of account in state, log them out
  useEffect(() => {
    if (authState.userType && authState.userType == UserTypes.requestor) {
      logout()
    }
  }, [authState])

  return (
    <>
      {authState.isLoading ? <LoadingPage /> : null}
      {!authState.isLoading && authState.jwt == null ? <CodeController /> : null}
      {!authState.isLoading && authState.accountInfo
        ? statusRenderer(authState.accountInfo.consent.status)
        : null}
    </>
  )
}

export default ApproverRouter
